import { goto } from "create-react-scaffold";
import { get, post } from "./ajax";

export function isProd() {
  return import.meta.env.PROD;
}

export function isDev() {
  return import.meta.env.DEV;
}

/**
 * 移除路径前后的空格
 * @param {*} pathname
 * @returns
 */
export function normalize(pathname) {
  return pathname.replace(/^\/*|\/*$/g, "");
}

/**
 * 页面跳转
 * @param {string} path
 * @param {*} param
 * @param {*} type
 * @returns
 */
export function go(path, param) {
  goto(path, param);
}

let UidIndex = 0;
export function uid() {
  const now = Date.now();
  const rand = Math.floor(Math.random() * 100);
  const index = UidIndex++;
  const num = Number(`${now}${rand}${index}`);
  return num.toString(36);
}

/**
 * 获取文件扩展名
 * @param {*} name
 * @returns
 */
export function getExtension(name) {
  const parts = name.split(".");
  const extension = parts.length >= 2 ? parts.pop() : "";
  return extension.toLowerCase();
}

/**
 * 上传图片 
 * @param {*} file 
 * @returns 
 */
export async function uploadPic(file) {
  const url = isProd() ? "https://service.chelun.com" : "http://service-test.chelun.com";
  const res = await get(`${url}/upload/token`, {
    ftype: 1,
  });
  const token = res.data?.token;
  const body = new FormData();
  body.append("file", file);
  body.append("token", token);
  const { code, message, data } = await post(`${url}/upload/image`, body);
  return data?.url || '';
}

/**
 * 删除对象上的空键
 */
export function deleteEmptyKey(obj) {
  for (var key in obj) {
    if (obj[key] === "" || obj[key] === undefined || obj[key] === null) {
      delete obj[key];
    }
  }
  return obj;
}